import { IParametro } from "@/entities";

export class Parametro implements IParametro {
  id: number;
  codParametro: string;
  codTipo?: string;
  desParametro?: string;
  active: boolean;
  selected: boolean;

  constructor() {
    this.id = 0;
    this.active = false;
    this.codParametro = "";
    this.selected = false;
  }
}
